import React from 'react';
import { trackEvent } from 'utils/google-tag-manager';
import PhoneIcon from 'components/icon/phone-icon';
import styles from '../style.module.scss';
import { GTM_CLICK_CALL_CTA } from 'constants/events';
import { useTranslation } from 'next-i18next';
import { LOCALE_CONNECTION_REQUEST_PATHS, Namespaces } from 'types/locales';

export type PhoneCTAProps = {
  readonly phoneNumber: string;
  readonly onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

const defaultOnClick: React.MouseEventHandler<HTMLAnchorElement> = () => {
  trackEvent(GTM_CLICK_CALL_CTA); // FIXME: event tracking should not be done in components, but in the container (e.g. the page, controller, etc.)
};

export default function PhoneCTA({ phoneNumber, onClick }: PhoneCTAProps) {
  const { t } = useTranslation(Namespaces.CONNECTION_REQUEST);
  return (
    <div className={styles['phone-number-container']}>
      <a href={`tel:${phoneNumber}`} className={styles['phone-number']} onClick={onClick || defaultOnClick}>
        <PhoneIcon /> {t(LOCALE_CONNECTION_REQUEST_PATHS.PHONE_CTA_CALL_US, { phoneNumber, defaultValue: 'Call us {{phoneNumber}}' })}
      </a>
    </div>
  );
}
